export class URLParams {
  constructor(url) {
    this.url = new URL(url)
  }

  set(name, value, saveState=false) {
    this.url.searchParams.set(name, value)
    if (window.history.replaceState && !saveState) {
      //prevents browser from storing history
      window.history.replaceState(name, document.title, this.url);
    }
    else if (window.history.pushState && saveState) {
      window.history.pushState(name, document.title, this.url)
    }
    else {
      window.location.href = this.url.toString()
    }
  }

  get(name) {
    return this.url.searchParams.get(name)
  }

  getAll(name) {
    return this.url.searchParams.getAll(name)
  }
}
